// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"594":"79aea34c","953":"7be54b4e"}[chunkId] + ".css";
};